import { render } from "./SurveyEffort.vue?vue&type=template&id=50ecd7bc"
import script from "./SurveyEffort.vue?vue&type=script&lang=js"
export * from "./SurveyEffort.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__